(function() {
  define('templates/helpers/arrayPropertiesEmpty',["handlebars", "underscore"], function(Handlebars, _) {
    return Handlebars.registerHelper("arrayPropertiesEmpty", function(array, property, options) {
      var success, x;
      x = _.find(array, property);
      success = x != null;
      if (success) {
        return options.fn(this);
      }
    });
  });

}).call(this);

//# sourceMappingURL=arrayPropertiesEmpty.js.map
;
